import jsonp from '../../utils/jsonp-util';
import { PASSPORT_ROOT_ADDRESS } from '@src/constants/urls';
import { CREATE_TINY_URL, ZT_ROOT_ADDRESS } from '../../constants/urls';

const passportRoot = PASSPORT_ROOT_ADDRESS;

const wrapJsonp = jsonp.customWrap;

export default class Services {
  /**
   * 获取区服列表
   * @param gameType
   * @returns {Promise<ServiceResponse>}
   */
  static getRecords(gameType) {
    const gameServer = gameType === 'jx3yq' ? 'jx3classicserver' : 'jx3server';
    return jsonp(`${ZT_ROOT_ADDRESS}/core/${gameServer}/get_records`).then(response => {
      if (response.code === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }
  /**
   * 获取有角色的区服列表
   * @returns {Promise<ServiceResponse>}
   */
  static getPlayedRecords(gameType) {
    const gameServer = gameType === 'jx3yq' ? 'jx3classicserver' : 'jx3server';
    return jsonp(`${ZT_ROOT_ADDRESS}/core/${gameServer}/get_played_records`).then(response => {
      if (response.code === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 获取剑网3缘起角色列表
   * @returns {Promise<ServiceResponse>}
   */
  static getRoleData(params) {
    const gameServer = params.gameType === 'jx3yq' ? 'jx3classicserver' : 'jx3role';
    return jsonp(`${ZT_ROOT_ADDRESS}/core/${gameServer}/get_played_roles`, { dbnum: params.dbnum }).then(response => {
      if (response.code === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * 生成短链
   * @param url
   * @returns {Promise<ServiceResponse>}
   */
  static createTinyUrl(url) {
    return jsonp(`${CREATE_TINY_URL}`, { url: url }).then(response => {
      if (response.code === 1) {
        return response.data;
      }
      return Promise.reject(response);
    });
  }

  /**
   * # 成功
   {
        "code": 1,                                                      # 状态码
        "message": "",                                                  # 提示信息
        "data": {                                                       # 数据
            "account": "xsjgw_0001",                                    # 当前登录账号
            "request_id": "10EDF172-691B-E3F3-391D-B328ED4B2E9E"        # 当前请求ID(用于日志查询)
        }
    }
   # 失败
   {
        "code": -20101,
        "message": "请先登录",
        "data": {
            "request_id": "766972AF-BC8E-010E-967B-308046DD6842"
        }
    }
   */
  static getInfo() {
    return wrapJsonp(passportRoot + '/get_info');
  }

  /**
   * 发送短信验证码(仅此文档中接口使用）
   * @param params -
   * phrase      (必选) 图片验证码
   * mobile      (必选) 手机号码
   * @return {Promise<*>}
   */
  static sendCode(params) {
    return wrapJsonp(passportRoot + '/send_code', {
      ...params,
      client: 'jx3'
    });
  }

  static preAuth(url, params) {
    return jsonp(url, params);
  }

  /**
   * 登录
   * @param params -
   * phrase      (图片或极验二选一) 图片验证码
   * account     (必选) 账号
   * password    (必选) 密码
   * tag         (可选) 验证码标签(0~16位, 用于一个页面需要显示多个验证码的场景)
   * geetest_challenge       (图片或极验二选一) 极验验证码信息字段
   * geetest_validate      (图片或极验二选一) 极验验证码信息字段
   * geetest_seccode      (图片或极验二选一) 极验验证码信息字段
   * @return {Promise<*>}
   */
  static login(params) {
    return wrapJsonp(passportRoot + '/login', params);
  }

  /**
   * 退出
   */
  static logout() {
    return wrapJsonp(passportRoot + '/logout');
  }

  /**
   * 剑网3免登退登
   * @returns {Promise<Object>}
   */
  static logoutIngame() {
    return wrapJsonp(ZT_ROOT_ADDRESS + '/core/jx3tools/logout');
  }

  /**
   * 注册
   * @param params -
   *
   * phrase      (可选) 验证码(如果手机号码验证了则不需要此参数)
   * account     (必选) 账号
   * password    (必选) 密码
   * tag         (可选) 验证码标签(0~16位, 用于一个页面需要显示多个验证码的场景)
   * from        (可选) 来源页(用于统计)
   * target      (可选) 页面区块标识(用于统计)
   * more        (可选) 是否填写更多信息(如more=1则检查以下参数)
   * name        (可选) 姓名
   * email       (可选) 邮箱
   * id_number   (可选) 身份证号码
   * mobile      (可选) 手机号码
   * code        (可选) 短信验证码
   * client      (可选) 客户端标识
   * @return {Promise<*>}
   */
  static registerMobile(params) {
    return wrapJsonp(passportRoot + '/register_mobile', Object.assign(params, { client: 'jx3' }));
  }

  /**
   * 检查用户是否存在
   * @param account - (必选) 账号
   * @return {Promise<*>}
   */
  static exist(account) {
    return wrapJsonp(passportRoot + '/exist', { account }).then(
      () => {
        return true;
      },
      response => {
        if (response.code === -20106) {
          return false;
        }
        return Promise.reject(response);
      }
    );
  }
}
